import { motion } from "framer-motion";
import { ArrowLeft, ArrowRight, Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import ButtonLoadingSpinner from "./ButtonLoadingCommponent";

//@ts-expect-error
const FooterNavigation = ({ onPrev, onNext, disabled, showCreate = false }) => {
  const { t } = useTranslation();

  return (
    <div className="lp-flex lp-justify-between lp-gap-4">
      {onPrev !== null && (
        <motion.button
          className="lp-group lp-flex-1 lp-bg-black/95 lp-backdrop-blur-sm lp-border lp-border-[#DDB889]/10
            lp-text-[#DDB889] lp-py-3 lp-px-6 lp-rounded-xl lp-font-medium
            lp-transition-all lp-duration-300 lp-flex lp-items-center lp-justify-center
            lp-relative lp-overflow-hidden
            hover:lp-border-[#DDB889]/20 hover:lp-shadow-[0_0_20px_rgba(221,184,137,0.2)]"
          onClick={onPrev}
          whileHover={{  }}
          whileTap={{ }}
        >
          <span className="lp-relative lp-z-10 lp-flex lp-items-center">
            <ArrowLeft className="lp-mr-2" size={16} />
            {t('booking.previous')}
          </span>
          <div className="lp-absolute lp-inset-0 lp-z-0">
            <div className="
              lp-absolute lp-inset-0
              lp-translate-x-[-100%]
              lp-bg-gradient-to-r lp-from-transparent lp-via-[#DDB889]/10 lp-to-transparent
              group-hover:lp-translate-x-[100%]
              lp-transition-transform lp-duration-700 lp-ease-in-out
            "/>
          </div>
        </motion.button>
      )}

      <motion.button
        className={`lp-group lp-flex-1 lp-bg-black/95 lp-backdrop-blur-sm lp-border lp-border-[#DDB889]/10
          lp-text-[#DDB889] lp-py-3 lp-px-6 lp-rounded-xl lp-font-medium
          lp-transition-all lp-duration-300 lp-flex lp-items-center lp-justify-center
          lp-relative lp-overflow-hidden
          ${disabled
            ? 'lp-opacity-50 lp-cursor-not-allowed'
            : 'hover:lp-border-[#DDB889]/20 hover:lp-shadow-[0_0_20px_rgba(221,184,137,0.2)]'
          }`}
        onClick={onNext}
        disabled={disabled}
        whileHover={disabled ? {} : {  }}
        whileTap={disabled ? {} : { }}
      >
        <span className="lp-relative lp-z-10 lp-flex lp-items-center">
        {disabled ? (
            <ButtonLoadingSpinner />
          ) : (
            <>
              {showCreate ? t('booking.create') : t('booking.next')}
              {showCreate ? <Check className="lp-ml-2" size={16} /> : <ArrowRight className="lp-ml-2" size={16} />}
            </>
          )}
        </span>
        <div className="lp-absolute lp-inset-0 lp-z-0">
          <div className={`
            lp-absolute lp-inset-0
            lp-translate-x-[-100%]
            lp-bg-gradient-to-r lp-from-transparent lp-via-[#DDB889]/10 lp-to-transparent
            ${!disabled && 'group-hover:lp-translate-x-[100%]'}
            lp-transition-transform lp-duration-700 lp-ease-in-out
          `}/>
        </div>
      </motion.button>
    </div>
  );
};

export default FooterNavigation;
